/**
 * Barra de pestañas del móvil, pegada abajo.
 *
 * POR QUÉ ABAJO Y NO SOLO EL MENÚ DE ARRIBA: en un teléfono el pulgar llega con comodidad a la
 * mitad de abajo de la pantalla; el botón de menú de la esquina de arriba obligaba a estirar la
 * mano (o a usar las dos) para cada cambio de sección, y escondía tras dos toques lo que se usa
 * diez veces al día.
 *
 * CUATRO ACCESOS Y «MÁS». Lo que se hace desde el móvil: mirar el inicio, ir a un piso, soltar
 * un ticket en su inmueble y buscar a un inquilino. Lo pendiente está en la campana de arriba.
 * El resto (suministros, documentos, seguimiento y la cuenta) sigue en el panel que abre «Más».
 *
 * Solo se ve por debajo de 720px (lo decide el CSS). Entre 720 y 900px, tableta en vertical,
 * sigue el botón de menú de la barra superior: ahí sobra anchura para él.
 */
import { NavLink } from 'react-router-dom';
import { Icon, type IconName } from './Icon';
import styles from './MobileTabBar.module.css';

interface Tab {
  to: string;
  /** Lo que se lee debajo del icono: corto, que caben cinco en 360px. */
  label: string;
  /** El nombre accesible, completo. */
  title: string;
  icon: IconName;
}

const TABS: Tab[] = [
  { to: '/', label: 'Inicio', title: 'Inicio', icon: 'home' },
  { to: '/propiedades', label: 'Propiedades', title: 'Propiedades', icon: 'building' },
  { to: '/ingresos-y-gastos', label: 'Gastos', title: 'Ingresos y gastos', icon: 'cash-flow' },
  { to: '/inquilinos', label: 'Inquilinos', title: 'Inquilinos', icon: 'users' },
];

interface MobileTabBarProps {
  /** Abre el panel lateral con el resto de secciones. */
  onOpenMore: () => void;
  /** El panel está abierto: «Más» se pinta activo. */
  moreOpen: boolean;
}

export function MobileTabBar({ onOpenMore, moreOpen }: MobileTabBarProps) {
  return (
    <nav className={styles.bar} aria-label="Accesos rápidos">
      {TABS.map((tab) => {
        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.to === '/'}
            className={({ isActive }) =>
              isActive && !moreOpen ? `${styles.tab} ${styles.tabActive}` : styles.tab
            }
            aria-label={tab.title}
          >
            <span className={styles.iconWrap}>
              <Icon name={tab.icon} size={21} />
            </span>
            <span className={styles.label} aria-hidden="true">
              {tab.label}
            </span>
          </NavLink>
        );
      })}
      <button
        type="button"
        className={moreOpen ? `${styles.tab} ${styles.tabActive}` : styles.tab}
        onClick={onOpenMore}
        aria-label="Más secciones"
        aria-expanded={moreOpen}
      >
        <span className={styles.iconWrap}>
          <Icon name="grid" size={21} />
        </span>
        <span className={styles.label} aria-hidden="true">
          Más
        </span>
      </button>
    </nav>
  );
}
